interface HealthBenefitsProps {
  title: string;
  description: string;
  benefits: string[];
}

export function HealthBenefits({ title, description, benefits }: HealthBenefitsProps) {
  return (
    <div className="rounded-md bg-green-50/50 p-3">
      <h4 className="mb-2 text-sm font-medium text-gray-700">
        <i className="fa fa-leaf mr-1.5 text-green-500" />
        {title}
      </h4>
      <p className="mb-3 text-sm leading-relaxed text-gray-600">
        {description}
      </p>
      <ul className="space-y-1.5">
        {benefits.map((benefit) => (
          <li key={benefit} className="flex items-center text-sm text-gray-600">
            <i className="fa fa-check mr-2 text-xs text-green-500" />
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
}
